/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../components/Menu/Utils/commonFunctions';
import PageContent from '../../../../components/PageContent/PageContent';
// import DebtTable from '../../../../components/Table/DebtTable';
import EquityTable from '../../../../components/Table/EquityTable';
// import ProjectFinanceTable from '../../../../components/Table/ProjectFinanceTable';
import MainTableTitle from '../../../../components/Table/Utils/MainTableTitle';
import Tabs from '../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../constants/permissionsEnum';
import {Itabs} from '../../../../interface/Tab';
import TranslatedText from '../../../../libraries/I18N/TranslatedText';
import Year from '../../../../shared/Year';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';

const Investment: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');

  const InvestmentTab: Itabs[] = [
    {
      id: 'equity_scope3',
      name: <TranslatedText translationKey="Investments" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <EquityTable selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerInvestmentEquityInvestments
      )
    }
    // {
    //   id: 'debt',
    //   name: <TranslatedText translationKey="Debt Investments" />,
    //   component: <DebtTable selectedYear={selectedYear} />
    // },
    // {
    //   id: 'projectFinance',
    //   name: <TranslatedText translationKey="Project Finance" />,
    //   component: <ProjectFinanceTable selectedYear={selectedYear} />
    // }
  ].filter((item) => !item.hidden);

  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
    setSelectedYear(currentYear);
  }, []);

  return (
    <PageContent>
      {selectedYear && (
        <>
          <MainTableTitle title="Investments" />
          <Year setSelectedYear={setSelectedYear} />
          <Tabs array={InvestmentTab} />
        </>
      )}
    </PageContent>
  );
};

export default Investment;
